export const ApplicationIntelligenceLoading = () => {
  return (
    <div className="flex justify-center items-center h-[200px]">
      <p className="text-content-200">Loading...</p>
    </div>
  );
};
